import { ViewerItem } from '$shared/components/Viewer/VieverItem/ViewerItem.interface';
import { AttachItem, AttachType } from '$store/models';
import { aesDecrypt } from '$utils/crypto';

export const attachmentToViewerItem = (
  item: AttachItem,
  decryptKey: string,
  instance?,
  part?,
): ViewerItem | null => {
  if (item.type === AttachType.PHOTO) {
    const { photo } = item;
    return {
      id: photo?.photoId || 0,
      instance,
      part,
      source:
        (decryptKey &&
        !['https', 'http', 'data'].some((i) => photo?.photoLarge.startsWith(i + ':'))
          ? aesDecrypt(photo?.photoLargeEncrypted, decryptKey)
          : photo?.photoLarge) || '',
      thumbnail: photo?.thumbnail,
      thumbHash: photo?.thumbHash,
      encrypted: photo?.encrypted,
      height: photo?.height || 0,
      width: photo?.width || 0,
    };
  } else if (item.type === AttachType.VIDEO) {
    const { video } = item;
    const jsonString = video?.encrypted
      ? aesDecrypt(video?.source, decryptKey)
      : video?.source;
    let source = '';
    try {
      source = jsonString ? JSON.parse(jsonString)[0].path : '';
    } catch (e) {}
    return {
      id: -(video?.videoId || 0),
      source: source,
      instance,
      part,
      thumbnail: video?.photoLarge,
      thumbHash: video?.thumbHash,
      height: video?.height || 0,
      width: video?.width || 0,
    };
  } else {
    return null;
  }
};

export const attachmentsToViewerItems = (
  items: AttachItem[],
  decryptKey: string,
  instance?,
): ViewerItem[] => {
  const viewerItems: ViewerItem[] = [];
  items.forEach((item) => {
    const viewerItem = attachmentToViewerItem(item, decryptKey, instance);
    if (viewerItem) {
      viewerItems.push(viewerItem);
    }
  });
  return viewerItems;
};
